module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-866712aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/date-picker.vue
// module id = 485
// module chunks = 2